import '../../../src/stylus/components/_grid.styl';
import Grid from './grid';
export default Grid('flex');
//# sourceMappingURL=VFlex.js.map